import React, { useState } from "react";
import * as Yup from "yup";
import "react-toastify/dist/ReactToastify.css";
import ClearIcon from "@mui/icons-material/Clear";
import "react-phone-input-2/lib/style.css";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import Image from "next/image";
import RequestSample from "../Contact-us/RequestSample";
import { usePathname } from "next/navigation";
import {
  trackFormLoaded,
  FORM_TYPES,
  getPageType,
} from "@/utils/gtmEvents";

const RequestSampleModalBtn = ({
  id,
  Options = [],
  chemicalName,
  heading,
  subHeading,
  subHeader,
  children,
  classes,
}) => {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();

  const handleClickOpen = () => {
    setOpen(true);

    // Track FORM_LOADED event when modal opens
    const pageUrl = typeof window !== "undefined" ? window.location.href : "";
    const pageType = getPageType(pathname);
    trackFormLoaded(FORM_TYPES.REQUEST_SAMPLE_QUOTES, pageUrl, pageType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <button className={classes} onClick={handleClickOpen}>
        {children}
      </button>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>
          <div className="flex justify-between">
            <div className="flex gap-[2px] ">
              {/* <div          
          className={`md:w-[35px]  md:h-[75px] w-[25px] h-[65px] bg-[${color}] whatWeDoBar edgeBar `}
        ></div> */}
              <Image
                src="https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709289729.svg"
                width={64}
                height={72}
                className="relative h-8 sm:h-14 md:h-16 ml-[-1rem]  sm:ml-[0] mb-2 "
                alt="brand-logo"
              />
              <div className="">
                <div className="sm:text-[30px]  text-[0.875rem]  font-normal  uppercase font-mukta mb-[4px]">
                  {heading}
                </div>
                <div
                  className={`md:text-[1rem] font-medium text-[0.8rem] text-[#4D4D4D]  `}
                >
                  {subHeading}
                </div>
              </div>
            </div>
            <ClearIcon className="cursor-pointer mt-4" onClick={handleClose} />
          </div>
        </DialogTitle>
        <DialogContent
          sx={{
            padding: "2rem !important",
          }}
        >
          {subHeader && (
            <table className="w-full my-7">
              <tr>
                <td className="w-[15%]">
                  <h4 className="font-medium text-[16px]">{subHeader}</h4>
                </td>
                <td className="w-[70%]">
                  <hr></hr>
                </td>
              </tr>
            </table>
          )}
          <RequestSample
            Options={Options}
            request_type={heading}
            id={id}
            chemicalName={chemicalName}
            handleClose={handleClose}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default RequestSampleModalBtn;
